<template>
  <!-- @vue-ignore -->
  <Doughnut
    ref="refElement"
    :key="key"
    :options="options"
    :data="chartData"
  />
</template>

<script setup lang="ts">
import {
  Chart as ChartJS, ArcElement, Tooltip,
} from 'chart.js';
import { Doughnut } from 'vue-chartjs';
import resolveConfig from 'tailwindcss/resolveConfig';
import useForceRender from '@/Composables/useForceRender';
import { type ChartData } from '@/types';
import tailwindConfig from '../../../../tailwind.config.js';

const { refElement, key } = useForceRender();

const { theme } = resolveConfig(tailwindConfig);

ChartJS.register(ArcElement, Tooltip);

const props = defineProps<{
  data: ChartData[];
  graphColours: App.Data.Settings.ReportDesign.GraphColoursData;
}>();

const options: any = {
  animation: {
    duration: 0,
  },
  borderRadius: {
    outerStart: 6,
    outerEnd: 6,
  },
  borderWidth: 2,
  cutout: '70%',
  hoverBorderColor: theme.colors.white,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: 'black',
      bodyAlign: 'center',
      displayColors: false,
      padding: 12,
      titleAlign: 'center',
    },
  },
  responsive: true,
};

const chartData: any = {
  labels: props.data.map((element) => element.label),
  datasets: [
    {
      backgroundColor: [
        props.graphColours.colourOne,
        props.graphColours.colourTwo,
        props.graphColours.colourThree,
        props.graphColours.colourFour,
      ],
      data: props.data.map((element) => element.value),
      hoverBackgroundColor: [
        props.graphColours.colourOne,
        props.graphColours.colourTwo,
        props.graphColours.colourThree,
        props.graphColours.colourFour,
      ],
    },
  ],
};
</script>
